<template>
  <div class="dropdown" v-if="requestRoute?.status">
    <span
      :class="{
        'partner-badge': true,
        'rounded-pill': true,
        'cursor-pointer':
          !requestRoute.assigned_driver_details &&
          $userPermission.has('vehicle-request-status-change'),
        'partner-badge-pink': requestRoute.assigned_driver_details,
        'partner-badge-primary': requestRoute.status === 'Requested',
        'partner-badge-success': requestRoute.status === 'Accepted',
        'partner-badge-info': requestRoute.status === 'Reviewed',
        'partner-badge-danger': requestRoute.status === 'Cancelled'
      }"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      data-bs-display="static"
      >{{
        requestRoute.assigned_driver_details ? 'Assigned' : requestRoute.status
      }}
      <i
        class="bi bi-chevron-down"
        v-if="
          !requestRoute.assigned_driver_details &&
          $userPermission.has('vehicle-request-status-change')
        "
      ></i
    ></span>
    <ul
      class="dropdown-menu partner-vr-tooltip"
      v-if="
        !requestRoute.assigned_driver_details &&
        $userPermission.has('vehicle-request-status-change')
      "
    >
      <li v-if="requestRoute.status !== 'Accepted'">
        <div class="dropdown-item">
          <span
            class="partner-badge partner-badge-success rounded-pill cursor-pointer"
            data-bs-toggle="modal"
            data-bs-target="#proposalModal"
            @click="$emit('selectRequest')"
            >Accept</span
          >
        </div>
      </li>
      <li
        v-if="
          !(
            requestRoute.status === 'Accepted' ||
            requestRoute.status === 'Cancelled'
          ) && pageName === 'trip_list'
        "
      >
        <div class="dropdown-item">
          <span
            class="partner-badge partner-badge-info rounded-pill cursor-pointer"
            data-bs-toggle="modal"
            data-bs-target="#remarksPartnersModal"
            @click="$emit('selectRequest')"
            >Review</span
          >
        </div>
      </li>
      <li
        v-if="requestRoute.fare_per_km && !requestRoute.assigned_driver_details"
      >
        <div class="dropdown-item">
          <span
            v-if="$userPermission.has('vehicle-request-driver-assign')"
            class="partner-badge partner-badge-pink rounded-pill cursor-pointer"
            data-bs-toggle="modal"
            data-bs-target="#assignDriverModal"
            @click="$emit('selectRequest')"
          >
            Assign
          </span>
          <span
            v-else
            class="partner-badge partner-badge-pink rounded-pill"
            @click="
              $partnerSwal.warningToast.fire({
                title: 'You don\'t have permission to assign driver!'
              })
            "
            >Assign</span
          >
        </div>
      </li>
      <li
        v-if="requestRoute.status !== 'Cancelled' && !requestRoute.fare_per_km"
      >
        <div class="dropdown-item">
          <span
            class="partner-badge partner-badge-danger rounded-pill cursor-pointer"
            data-bs-toggle="modal"
            data-bs-target="#cancelProposalModal"
            @click="$emit('selectRequest')"
            >Cancel</span
          >
        </div>
      </li>
    </ul>
  </div>
  <span v-else>N/A</span>
</template>

<script>
export default {
  props: ['pageName', 'requestRoute'],
  data() {
    return {};
  }
};
</script>
